module.exports = __webpack_public_path__ + "static/newfoundland-and-labrador-c335a52bbef763d411d4b8d29468407a.png";